var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedObjectTypeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "#10A4E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9116 11.175L8.33608 15.8915C7.94566 16.1062 7.49056 15.7416 7.61503 15.3137L8.94649 10.7368L7.61503 6.15995C7.49056 5.7321 7.94566 5.36744 8.33608 5.58217L16.9116 10.2987C17.257 10.4887 17.257 10.985 16.9116 11.175Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94649 10.7368L7.61503 6.15995C7.49056 5.7321 7.94566 5.36744 8.33608 5.58217L16.9116 10.2987C17.257 10.4887 17.257 10.985 16.9116 11.175L8.33608 15.8915C7.94566 16.1062 7.49056 15.7416 7.61503 15.3137L8.94649 10.7368ZM8.94649 10.7368H12.2843",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 10.7365L11.5895 10.7365",
    stroke: "#10A4E5",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedObjectTypeIcon);
export default __webpack_public_path__ + "static/media/SelectedObjectTypeIcon.61e6c0a0538b6b324e40064512533460.svg";
export { ForwardRef as ReactComponent };